import apiRequest from './api';
import { BASE_API_URL } from "../config/constant";

export const startWealthboxOAuth = () => apiRequest('get', `${ BASE_API_URL }/wealthbox/start-auth`).then((res) => res.data);

export const disConnectProvider = (provider: 'WEALTHBOX' | 'REDTAIL' | 'SALESFORCE' | null) => apiRequest('del', `${ BASE_API_URL }/wealthbox/disconnect/provider`, {
  body: {
    provider,
  }
}).then((res) => res.data);